import { useMemo } from "react";
import { Text } from "@chakra-ui/react";
import { IFeedCardNumberBody } from "src/components/feed-card/types/content";
import { EnumFeedCardNumberFormat } from "src/components/feed-card/types/enums";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";
import { getPerformanceColor } from "src/utils/color-util";

export const FeedCardNumber = ({ format, value }: IFeedCardNumberBody) => {
    const { formatNumber, formatPerformance, formatPercent, formatNumberWithSign } = useNumberFormatter();

    const formattedValue = useMemo(() => {
        switch (format) {
            case EnumFeedCardNumberFormat.Percent:
                return formatPercent(value, 1);

            case EnumFeedCardNumberFormat.IntegerWithSign:
                return formatNumberWithSign(value);

            case EnumFeedCardNumberFormat.Performance:
                return formatPerformance(value, 1);

            case EnumFeedCardNumberFormat.Default:
                return formatNumber(value);

            default:
                const unsupportedFormat = (_format: never, value: number) => formatNumber(value);

                return unsupportedFormat(format, value);
        }
    }, [format, formatNumber, formatNumberWithSign, formatPercent, formatPerformance, value]);

    const color = format === EnumFeedCardNumberFormat.Performance ? getPerformanceColor(formattedValue) : undefined;

    return (
        <Text as="span" color={color}>
            {formattedValue}
        </Text>
    );
};
